"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = require("react-helmet");

var _moment = _interopRequireDefault(require("moment"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BlogPostSchema = function BlogPostSchema(_ref) {
  var datePublished = _ref.datePublished,
      title = _ref.title,
      heroImage = _ref.heroImage,
      author = _ref.author,
      content = _ref.content,
      summary = _ref.summary;
  var data = {
    '@context': 'http://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    datePublished: (0, _moment["default"])(datePublished).format('YYYY-MM-DD'),
    description: summary,
    articleBody: content
  };

  if (author) {
    data = _objectSpread(_objectSpread({}, data), {}, {
      author: {
        '@type': 'Person',
        name: author
      }
    });
  }

  if (heroImage && typeof heroImage === 'string') {
    data = _objectSpread(_objectSpread({}, data), {}, {
      image: {
        '@type': 'ImageObject',
        url: heroImage
      }
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(data)));
};

var _default = BlogPostSchema;
exports["default"] = _default;
BlogPostSchema.propTypes = {
  title: _propTypes["default"].string.isRequired,
  datePublished: _propTypes["default"].string.isRequired,
  author: _propTypes["default"].string,
  heroImage: _propTypes["default"].string,
  content: _propTypes["default"].string.isRequired,
  summary: _propTypes["default"].string
};
BlogPostSchema.defaultProps = {
  heroImage: null,
  author: null,
  summary: ''
};